import React from 'react';
import { Button, Dropdown, Tooltip } from 'antd';
import type { MenuProps } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { USER_GUIDES } from '../Constants/userGuides';

const iconStyle: React.CSSProperties = { fontSize: 20, color: 'white' };

/**
 * Help icon of the header: a menu of the guides (PDFs) of every role, the chosen one opens in a new tab.
 * Nothing is shown if the guides url is not configured.
 */
const UserGuideButton = (): React.ReactNode => {
  const { t } = useTranslation();

  if (USER_GUIDES.length === 0) return null;

  const items: MenuProps['items'] = [
    {
      key: 'title',
      type: 'group',
      label: t('header.userGuide'),
      children: USER_GUIDES.map((guide) => ({
        key: guide.labelKey,
        label: (
          <a href={guide.url} target="_blank" rel="noopener noreferrer">
            {t(guide.labelKey)}
          </a>
        ),
      })),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Tooltip title={t('header.userGuide')}>
        <Button
          type="text"
          aria-label={t('header.userGuide')}
          icon={<QuestionCircleOutlined style={iconStyle} />}
        />
      </Tooltip>
    </Dropdown>
  );
};

export default UserGuideButton;
